import script from "./CarouselContent.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselContent.vue?vue&type=script&setup=true&lang=js"

import "./CarouselContent.vue?vue&type=style&index=0&id=964e1fca&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-964e1fca"]])

export default __exports__